import React, {useEffect} from 'react';
import {Helmet} from "react-helmet";
import {
  Link,
} from "react-router-dom";

import {connect} from 'react-redux';
import {format, addMonths} from 'date-fns';
import {Actions as PAYMENTACTIONS} from '../store/actions/paymentActions';

import RegistrationForm from '../components/common/RegistrationForm'
import TimelineExample from '../components/common/TimelineExample'
import MaltaFeatures from '../components/features/MaltaFeatures'
import Team from '../components/team/Team'
import Pricing from '../components/pricing/Pricing'
import Testimonials from '../components/testimonials/Testimonials'
import Security from '../components/security/Security'


import MaltaFlag from '../assets/flags/malta.svg';

import mcDonaldsLogo from '../assets/images/mc-donalds.png';
import sixteenLogo from '../assets/images/sixteen.png';
import myokaLogo from '../assets/images/myoka.png';
import skySpiritLogo from '../assets/images/sky-spirit.png';
import buddyXero from '../assets/images/xero/Buddy-Payroll-Xero-Cloud-Accounting.png';
import xeroSceenshot from '../assets/images/xero/xero-screenshot.png';
import SeoHeaders from "../components/SeoHeaders";


function Xero({
  selectBundle,
  getBundles,
  bundles
}) {

  useEffect(() => {
    getBundles()
  },[]);


  useEffect(() => {
    if (bundles){
      selectBundle(bundles.find(item => item.name == "250 Credits"))
    }
  },[bundles]);

  return (

    <React.Fragment>

        <SeoHeaders
            title={`[country] Xero Payroll Integration by Buddy`}
            description={"Link up [country] payroll with your Xero Account; with one-click ledger submissions"}
        />

      <main className="mt-8 sm:mt-16 md:mt-20 lg:mb-24 mb-8 sm:mb-16 md:mb-20 lg:mb-24">
        <div className="mx-auto max-w-screen-xl">
          <div className="lg:grid lg:grid-cols-12 lg:gap-8">
            <div className="px-4 sm:px-6 sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left lg:flex lg:items-center">
              <div>
                
                <h1 className="mt-4 text-4xl tracking-tight leading-10 font-extrabold text-white sm:mt-5 sm:leading-none sm:text-6xl lg:mt-6 lg:text-5xl xl:text-6xl">
                  <span className="text-orange-400">Buddy</span> + Xero
                  <br/>
                  <span className="text-3xl">Cloud Payroll &amp; Accounting done right</span>
                </h1>
                <p className="mt-3 text-base text-gray-300 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
                  Cloud Payroll &amp; Accounting has never been easier.
                  This powerful combination allows you manage timesheets and absences;
                  convert those to payroll using Buddy and send the transactions back to Xero.
                  Reconciling payroll with your accounts and bank transfers has never been easier.
                </p>


                <div className="flex justify-between mt-5">
                  <span className="block rounded-md shadow-sm">
                    <a href="https://api.buddy.hr/v2/xero/connect" type="submit" className="flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-orange-600 hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange active:bg-orange-700 transition duration-150 ease-in-out">
                      Sign-up to Buddy with Xero
                    </a>
                  </span>
                  <span className="block rounded-md shadow-sm">
                    <a href="https://xero.com/signup/?xtid=x30buddy" className="flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white focus:outline-none transition duration-150 ease-in-out" style={{backgroundColor:"#13b6ea"}}>
                      Try Xero For Free
                    </a>
                  </span>
                </div>
                <p className="mt-8 text-sm text-white uppercase tracking-wide font-semibold sm:mt-10">Used by</p>
                <div className="mt-5 w-full sm:mx-auto sm:max-w-lg lg:ml-0">
                  <div className="flex flex-wrap items-start justify-between">
                    <div className="flex justify-center px-1">
                      <img className="h-9 sm:h-10" src={sixteenLogo} alt="Sixteen"/>
                    </div>
                    <div className="flex justify-center px-1">
                      <img className="h-9 sm:h-10" src={myokaLogo} alt="Myoka Spas"/>
                    </div>
                    <div className="flex justify-center px-1">
                      <img className="h-9 sm:h-10" src={skySpiritLogo} alt="Sky Spirit"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-12 sm:mt-16 lg:mt-0 lg:col-span-6">
              {/*<RegistrationForm/>*/}
              <div className="flex flex-row-reverse">
                <svg style={{width:200}} id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1474 850.4"><defs></defs><title>logo</title><path fill="#13b5ea" d="M426.6,719.1c162.3,0,293.9-131.6,293.9-293.9S588.9,131.3,426.6,131.3s-294,131.6-294,293.9,131.6,293.9,294,293.9"/><path fill="#fff" d="M273.3,424.4l50.2-50.3a9,9,0,0,0-12.8-12.7l-50.1,50.1-50.4-50.1a8.8,8.8,0,0,0-6.3-2.6,8.9,8.9,0,0,0-6.3,15.3l50.2,50.2-50.2,50.2a9,9,0,0,0,6.3,15.4,8.8,8.8,0,0,0,6.3-2.6l50.3-50.2,50.1,50a8.6,8.6,0,0,0,6.5,2.8,9,9,0,0,0,9-9,9.2,9.2,0,0,0-2.6-6.3Z"/><path fill="#fff" d="M571.5,424.3a16.4,16.4,0,1,0,32.7,0,16.4,16.4,0,0,0-32.7,0"/><path fill="#fff" d="M540.5,424.3a47.3,47.3,0,1,1,47.4,47.3,47.5,47.5,0,0,1-47.4-47.3m-18.6,0a66,66,0,1,0,66-65.9,66,66,0,0,0-66,65.9"/><path fill="#fff" d="M517.3,359.6h-2.8a37.7,37.7,0,0,0-23,7.7,9,9,0,0,0-8.8-7,8.9,8.9,0,0,0-8.9,8.9v111a9.1,9.1,0,0,0,9,8.9,8.9,8.9,0,0,0,9-8.9V411.9c0-22.7,2.1-31.9,21.6-34.4,1.8-.2,3.8-.2,3.8-.2,5.3-.1,9.1-3.8,9.1-8.8a9,9,0,0,0-9-8.9"/><path fill="#fff" d="M344.7,413.5v-.8a47.6,47.6,0,0,1,92.5.8Zm110.9-1.7c-3.9-18.3-13.9-33.4-29.2-43.1a66,66,0,0,0-101.2,56.1,61.9,61.9,0,0,0,2,15.9,66.4,66.4,0,0,0,55.9,49.2,67.6,67.6,0,0,0,43.4-10c6.4-4.1,11.7-9.5,16.9-15.9l.3-.4c3.6-4.4,2.9-10.8-1-13.8s-8.9-3.5-13.3,2.1a48.1,48.1,0,0,1-16.2,14.6,46.7,46.7,0,0,1-22.1,5.5c-26.1-.2-40.1-18.5-45.1-31.5a60.4,60.4,0,0,1-2-7.6c0-.5-.1-.9-.1-1.4h93.8c12.9-.2,19.8-9.3,17.9-19.7"/><path className="cls-3" fill="#231f20" d="M1047,718.9c162.3,0,293.9-131.6,293.9-294S1209.3,131,1047,131,753.1,262.6,753.1,424.9s131.6,294,293.9,294"/><path fill="#fff" d="M874.8,379.2c-1.2,0-1.9-.5-3.2-1.4a12.5,12.5,0,0,0-6.9-2c-7.9,0-11.7,5.3-11.7,16.6V401c0,11.8,3.7,16.4,11.2,16.4a13.1,13.1,0,0,0,7.6-2.2,7.1,7.1,0,0,1,3.3-1.4,3.6,3.6,0,0,1,3.6,3.8,4.7,4.7,0,0,1-1.6,3.3c-3.4,3.2-9,4.5-12.9,4.5-14.5,0-19.9-9.9-19.9-24.4v-8.8c0-13.9,5.5-24.3,20.4-24.3,4.4,0,9.3,1.3,12.3,4.1a5,5,0,0,1,1.8,3.3A3.9,3.9,0,0,1,874.8,379.2Z"/><path fill="#fff" d="M905.6,425.5c-14.7,0-19.6-10.4-19.6-20.9v-16c0-10.4,4.9-20.7,19.6-20.7s19.7,10.3,19.7,20.7v16C925.3,415.1,920.3,425.5,905.6,425.5Zm11-36.9c0-7.2-2.6-12.7-11-12.7s-10.8,5.4-10.8,12.7v16c0,7.3,2.5,12.8,10.8,12.8s11-5.5,11-12.8Z"/><path fill="#fff" d="M971.1,425.4a4.6,4.6,0,0,1-4.3-2.2L944.2,386v35.4a4,4,0,0,1-4,4,4.1,4.1,0,0,1-4.1-4V371.9a4,4,0,0,1,4.3-4,4.7,4.7,0,0,1,4.3,2.3l22.6,37.1V371.9a4.1,4.1,0,0,1,8.1,0v49.5A4.1,4.1,0,0,1,971.1,425.4Z"/><path fill="#fff" d="M1022.3,425.4a4.6,4.6,0,0,1-4.3-2.2L995.4,386v35.4a4,4,0,0,1-4,4,4.1,4.1,0,0,1-4.1-4V371.9a4,4,0,0,1,4.3-4,4.9,4.9,0,0,1,4.4,2.3l22.5,37.1V371.9a4.1,4.1,0,0,1,8.1,0v49.5A4.1,4.1,0,0,1,1022.3,425.4Z"/><path fill="#fff" d="M1068.6,424.7h-25.9a4.2,4.2,0,0,1-4.2-4.2V372.8a4.2,4.2,0,0,1,4.2-4.2h24.9a4.1,4.1,0,0,1,4.1,4.2,4.1,4.1,0,0,1-4.1,4.1h-20.3v15.7h18.4a4.1,4.1,0,0,1,0,8.1h-18.4v15.7h21.3a4.1,4.1,0,0,1,4.2,4.1A4.2,4.2,0,0,1,1068.6,424.7Z"/><path fill="#fff" d="M1110.7,379.2c-1.2,0-1.9-.5-3.2-1.4a12.2,12.2,0,0,0-6.9-2c-7.9,0-11.6,5.3-11.6,16.6V401c0,11.8,3.6,16.4,11.1,16.4a13.6,13.6,0,0,0,7.7-2.2,6.8,6.8,0,0,1,3.2-1.4,3.6,3.6,0,0,1,3.6,3.8,4.4,4.4,0,0,1-1.6,3.3c-3.4,3.2-8.9,4.5-12.9,4.5-14.4,0-19.9-9.9-19.9-24.4v-8.8c0-13.9,5.5-24.3,20.4-24.3,4.4,0,9.3,1.3,12.3,4.1a4.6,4.6,0,0,1,1.8,3.3A3.9,3.9,0,0,1,1110.7,379.2Z"/><path fill="#fff" d="M1157,377h-13.1v44a4.4,4.4,0,1,1-8.7,0V377H1122a4.2,4.2,0,0,1-4.2-4.2,4.2,4.2,0,0,1,4.2-4.2h35a4.2,4.2,0,0,1,4.3,4.2A4.2,4.2,0,0,1,1157,377Z"/><path fill="#fff" d="M1198,424.7h-26a4.1,4.1,0,0,1-4.1-4.2V372.8a4.1,4.1,0,0,1,4.1-4.2h24.9a4.2,4.2,0,0,1,4.2,4.2,4.1,4.1,0,0,1-4.2,4.1h-20.2v15.7h18.4a4.1,4.1,0,0,1,0,8.1h-18.4v15.7H1198a4.1,4.1,0,0,1,4.2,4.1A4.2,4.2,0,0,1,1198,424.7Z"/><path fill="#fff" d="M1229.9,424.7h-14.8a4.4,4.4,0,0,1-4.4-4.4V372.9a4.4,4.4,0,0,1,4.4-4.3h14.8c17.1,0,19.8,12.4,19.8,20.9v14.4C1249.7,412.4,1247,424.7,1229.9,424.7Zm11.1-35.1c0-6.9-2.1-12.7-11.7-12.7h-9.8v39.5h9.8c9.7,0,11.7-5.7,11.7-12.5Z"/><path fill="#fff" d="M1018.2,501.4a4.3,4.3,0,0,1-4.3-3.5c-.7-3.2-1.7-6.5-2.5-9.6h-20c-1,3.1-1.8,6.4-2.6,9.6a4.1,4.1,0,0,1-4.1,3.5,4.2,4.2,0,0,1-4.2-5.3,323.3,323.3,0,0,1,15.3-47.6c1.7-3.9,3.7-4.7,5.7-4.7s4.1.8,5.7,4.7a323.3,323.3,0,0,1,15.3,47.6A4.3,4.3,0,0,1,1018.2,501.4Zm-16.8-43.7c-2.9,7.4-5.5,15-7.9,22.7h15.7C1006.8,472.7,1004.2,465.1,1001.4,457.7Z"/><path fill="#fff" d="M1049,479.2h-10.9V497a4.3,4.3,0,0,1-4.4,4.4,4.4,4.4,0,0,1-4.4-4.4V448.9a4.4,4.4,0,0,1,4.4-4.3h14.6c13.4,0,17.8,8,17.8,15.5V464C1066.1,473,1059.8,479.2,1049,479.2Zm8.3-18.9c0-3.6-1.9-7.5-9.6-7.5h-9.6v18.4h10.6c6.3,0,8.6-3.5,8.6-7.3Z"/><path fill="#fff" d="M1094.5,479.2h-10.9V497a4.3,4.3,0,0,1-4.4,4.4,4.4,4.4,0,0,1-4.4-4.4V448.9a4.4,4.4,0,0,1,4.4-4.3h14.7c13.3,0,17.7,8,17.7,15.5V464C1111.6,473,1105.3,479.2,1094.5,479.2Zm8.3-18.9c0-3.6-1.9-7.5-9.6-7.5h-9.6v18.4h10.6c6.3,0,8.6-3.5,8.6-7.3Z"/></svg>
              </div>
              <img className="relative mx-auto" width="490" src={buddyXero} alt=""/>
            </div>
          </div>
        </div>
      </main>

      <div id='features' className="py-16 bg-gray-50 overflow-hidden lg:py-24">
        <div className="relative max-w-xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-screen-xl">
          <svg className="hidden lg:block absolute left-full transform -translate-x-1/2 -translate-y-1/4" width="404" height="784" fill="none" viewBox="0 0 404 784">
            <defs>
              <pattern id="b1e6e422-73f8-40a6-b5d9-c8586e37e0e7" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                <rect x="0" y="0" width="4" height="4" className="text-gray-200" fill="currentColor" />
              </pattern>
            </defs>
            <rect width="404" height="784" fill="url(#b1e6e422-73f8-40a6-b5d9-c8586e37e0e7)" />
          </svg>

          <div className="relative">
            <h3 className="text-center text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl sm:leading-10">
              Why connect Buddy to Xero?
            </h3>
            {/*<p className="mt-4 max-w-3xl mx-auto text-center text-xl leading-7 text-gray-500">
              Cut out the errors &.
            </p>*/}
          </div>

          <div className="relative mt-12 lg:mt-24 lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center">
            <div className="relative">
              <h4 className="text-2xl leading-8 font-extrabold text-gray-900 tracking-tight sm:text-3xl sm:leading-9">
                Payroll &amp; Accounting become one
              </h4>
              <p className="mt-3 text-lg leading-7 text-gray-500">
                Forget about Payroll Journal entries, let Buddy &amp; Xero handle the data.
              </p>

              <ul className="mt-10">
                <li>
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white">
                        {/* Heroicon name: globe-alt */}
                        <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                        </svg>
                      </div>
                    </div>
                    <div className="ml-4">
                      <h5 className="text-lg leading-6 font-medium text-gray-900">Easily Configurable</h5>
                      <p className="mt-2 text-base leading-6 text-gray-500">
                        Reduce mistakes with easy to use mapping functions between salary components and nominal codes.
                      </p>
                    </div>
                  </div>
                </li>
                <li className="mt-10">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white">
                        {/* Heroicon name: lightning-bolt */}
                        <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                        </svg>
                      </div>
                    </div>
                    <div className="ml-4">
                      <h5 className="text-lg leading-6 font-medium text-gray-900">Consolidated or Per-Employee Bills</h5>
                      <p className="mt-2 text-base leading-6 text-gray-500">
                        Do you use Bulk Salary payments? Buddy can send either consolidated payroll data into Xero, or else Bulk entries into a single bill.
                        This way reconciling your salary payments with the bank statments has never been easy.
                      </p>
                    </div>
                  </div>
                </li>
                <li className="mt-10">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white">
                        {/* Heroicon name: scale */}
                        <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3" />
                        </svg>
                      </div>
                    </div>
                    <div className="ml-4">
                      <h5 className="text-lg leading-6 font-medium text-gray-900">Automated Payroll Tax Bills</h5>
                      <p className="mt-2 text-base leading-6 text-gray-500">
                        Payroll Tax bills are created automatically with each payroll inside xero, with the correct due date.
                        This way you never miss paying payroll taxes again!
                      </p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>

            <div className="mt-10 -mx-4 relative lg:mt-0 flex justify-center">
              
              <div className="flow-root bg-white p-5 rounded-md shadow-md" style={{width: 480}}>
                  <ul className="-mb-4">

                    <li>
                      <div className="relative pb-8">
                        <span className="absolute top-5 left-5 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true"></span>
                        <div className="relative flex items-start space-x-3">
                          <div className="relative">
                            <img className="h-10 w-10 rounded-full bg-gray-400 flex items-center justify-center ring-8 ring-white" src="https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=facearea&amp;facepad=8&amp;w=256&amp;h=256&amp;q=80" alt=""/>

                            <span className="absolute -bottom-0.5 -right-1 bg-white rounded-tl px-0.5 py-px">
                              <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"></path></svg>
                            </span>
                          </div>
                          <div className="min-w-0 flex-1">
                            <div>
                              <div className="text-sm">
                                <span className="font-medium text-gray-900">Jason Borg</span>
                              </div>
                              <p className="mt-0.5 text-sm text-gray-500">
                                Paid <span className="font-bold">{format(addMonths(new Date(),-1),"MMMM")}</span>'s Payroll Tax in Xero
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="relative pb-8">
                        <span className="absolute top-5 left-5 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true"></span>
                        <div className="relative flex items-start space-x-3">
                          <div className="relative">
                            <img className="h-10 w-10 rounded-full bg-gray-400 flex items-center justify-center ring-8 ring-white" src="https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=facearea&amp;facepad=8&amp;w=256&amp;h=256&amp;q=80" alt=""/>

                            <span className="absolute -bottom-0.5 -right-1 bg-white rounded-tl px-0.5 py-px">
                              <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path></svg>
                            </span>
                          </div>
                          <div className="min-w-0 flex-1">
                            <div>
                              <div className="text-sm">
                                <span className="font-medium text-gray-900">Jason Borg</span>
                              </div>
                              <p className="mt-0.5 text-sm text-gray-500">
                                Sent <span className="font-bold">{format(new Date(),"MMMM")}</span>'s Payroll to Xero 3 days ago
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="relative pb-8">
                        <span className="absolute top-5 left-5 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true"></span>
                        <div className="relative flex items-start space-x-3">
                          <div className="relative">
                            <img className="h-10 w-10 rounded-full bg-gray-400 flex items-center justify-center ring-8 ring-white" src="https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=facearea&amp;facepad=8&amp;w=256&amp;h=256&amp;q=80" alt=""/>

                            <span className="absolute -bottom-0.5 -right-1 bg-white rounded-tl px-0.5 py-px">
                              <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"></path></svg>
                            </span>
                          </div>
                          <div className="min-w-0 flex-1">
                            <div>
                              <div className="text-sm">
                                <span className="font-medium text-gray-900">Jason Borg</span>
                              </div>
                              <p className="mt-0.5 text-sm text-gray-500">
                                Reconciled <span className="font-bold">{format(addMonths(new Date(),-1),"MMMM")}</span>'s Payroll Payments in Xero 23 days ago
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="relative pb-8">
                        <span className="absolute top-5 left-5 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true"></span>
                        <div className="relative flex items-start space-x-3">
                          <div className="relative">
                            <img className="h-10 w-10 rounded-full bg-gray-400 flex items-center justify-center ring-8 ring-white" src="https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=facearea&amp;facepad=8&amp;w=256&amp;h=256&amp;q=80" alt=""/>

                            <span className="absolute -bottom-0.5 -right-1 bg-white rounded-tl px-0.5 py-px">
                              <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path></svg>
                            </span>
                          </div>
                          <div className="min-w-0 flex-1">
                            <div>
                              <div className="text-sm">
                                <span className="font-medium text-gray-900">Jason Borg</span>
                              </div>
                              <p className="mt-0.5 text-sm text-gray-500">
                                Sent <span className="font-bold">{format(addMonths(new Date(),-1),"MMMM")}</span>'s Payroll to Xero 25 days ago
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="relative pb-8">
                        <span className="absolute top-5 left-5 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true"></span>
                        <div className="relative flex items-start space-x-3">
                          <div className="relative">
                            <img className="h-10 w-10 rounded-full bg-gray-400 flex items-center justify-center ring-8 ring-white" src="https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=facearea&amp;facepad=8&amp;w=256&amp;h=256&amp;q=80" alt=""/>

                            <span className="absolute -bottom-0.5 -right-1 bg-white rounded-tl px-0.5 py-px">
                              <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"></path><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path></svg>
                            </span>
                          </div>
                          <div className="min-w-0 flex-1">
                            <div>
                              <div className="text-sm">
                                <span className="font-medium text-gray-900">Jason Borg</span>
                              </div>
                              <p className="mt-0.5 text-sm text-gray-500">
                                Updated the Buddy-Xero Configuration 28 days ago
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="relative pb-8">
                        <div className="relative flex items-start space-x-3">
                          <div className="relative">
                            <img className="h-10 w-10 rounded-full bg-gray-400 flex items-center justify-center ring-8 ring-white" src="https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=facearea&amp;facepad=8&amp;w=256&amp;h=256&amp;q=80" alt=""/>

                            <span className="absolute -bottom-0.5 -right-1 bg-white rounded-tl px-0.5 py-px">
                              <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"></path></svg>
                            </span>
                          </div>
                          <div className="min-w-0 flex-1">
                            <div>
                              <div className="text-sm">
                                <span className="font-medium text-gray-900">Jason Borg</span>
                              </div>
                              <p className="mt-0.5 text-sm text-gray-500">
                                Connected Buddy to Xero 29 days ago
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>

              {/*<img className="relative mx-auto" width="490" src="https://tailwindui.com/img/features/feature-example-1.png" alt=""/>*/}
            </div>
          </div>

          <svg className="hidden lg:block absolute right-full transform translate-x-1/2 translate-y-12" width="404" height="784" fill="none" viewBox="0 0 404 784">
            <defs>
              <pattern id="64e643ad-2176-4f86-b3d7-f2c5da3b6a6d" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                <rect x="0" y="0" width="4" height="4" className="text-gray-200" fill="currentColor" />
              </pattern>
            </defs>
            <rect width="404" height="784" fill="url(#64e643ad-2176-4f86-b3d7-f2c5da3b6a6d)" />
          </svg>

          <div className="relative mt-12 sm:mt-16 lg:mt-24">
            <div className="lg:grid lg:grid-flow-row-dense lg:grid-cols-2 lg:gap-8 lg:items-center">
              <div className="lg:col-start-2">
                <h4 className="text-2xl leading-8 font-extrabold text-gray-900 tracking-tight sm:text-3xl sm:leading-9">
                  Discover Buddy
                </h4>
                <p className="mt-3 text-lg leading-7 text-gray-500">
                  Buddy takes the complexity out of payroll, enabling business owners &amp; HR managers to issue payroll accurately &amp; efficiently.
                </p>

                <ul className="mt-10">
                  <li>
                    <div className="flex">
                      <div className="flex-shrink-0">
                        <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white">
                          {/* Heroicon name: globe-alt */}
                          <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                          </svg>
                        </div>
                      </div>
                      <div className="ml-4">
                        <h5 className="text-lg leading-6 font-medium text-gray-900">Instant Calculations &amp; Payslip Previews</h5>
                        <p className="mt-2 text-base leading-6 text-gray-500">
                          Our payroll process allows you instantly edit and view draft payslips as you're working on your payroll.
                          Reducing the likelyhood of mistakes and payroll complications.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="mt-10">
                    <div className="flex">
                      <div className="flex-shrink-0">
                        <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white">
                          {/* Heroicon name: lightning-bolt */}
                          <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                          </svg>
                        </div>
                      </div>
                      <div className="ml-4">
                        <h5 className="text-lg leading-6 font-medium text-gray-900">Time &amp; Attendance Rule Engine</h5>
                        <p className="mt-2 text-base leading-6 text-gray-500">
                          Buddy's time and attendance rule engine allows you to easily convert your timesheets into payroll data.
                          Rules can be customised to your business requirements.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="mt-10">
                    <div className="flex">
                      <div className="flex-shrink-0">
                        <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white">
                          {/* Heroicon name: annotation */}
                          <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
                          </svg>
                        </div>
                      </div>
                      <div className="ml-4">
                        <h5 className="text-lg leading-6 font-medium text-gray-900">Employee Portal</h5>
                        <p className="mt-2 text-base leading-6 text-gray-500">
                          Employees can access their easy-to-understand payslips securely through the portal at any time. Be it their computer, tablet or phone.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="mt-10">
                    <div className="flex">
                      <div className="flex-shrink-0">
                        <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white">
                          {/* Heroicon name: mail */}
                          <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                          </svg>
                        </div>
                      </div>
                      <div className="ml-4">
                        <h5 className="text-lg leading-6 font-medium text-gray-900">Vacation Management</h5>
                        <p className="mt-2 text-base leading-6 text-gray-500">
                          Employees can apply for vacation leave and view their balances at any time.
                          Whilst managers get instant email notifications and can approve vacation at their convenience.
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>

              <TimelineExample/>
            </div>
          </div>
        </div>
      </div>


      <div id='about-xero' className="py-16 overflow-hidden lg:py-24">
        <div className="relative max-w-xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-screen-xl">

          <div className="relative">
            <h3 className="text-center text-3xl leading-8 font-extrabold tracking-tight text-white sm:text-4xl sm:leading-10">
              About Xero
            </h3>
            <p className="mt-4 max-w-3xl mx-auto text-center text-xl leading-7 text-white">
              Xero is world-leading online accounting software built for small businesses.
            </p>
          </div>

          <div className="relative mt-12 lg:mt-24 lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center">
            <div className="relative">
              <ul className="mt-10">
                <li>
                  <div className="flex">
                    <div className="ml-4">
                      <h5 className="text-lg leading-6 font-medium text-white">Get a real-time view of your cashflow.</h5>
                      <p className="mt-2 text-base leading-6 text-white">
                        Log in anytime, anywhere on your Mac, PC, tablet of phone to get a real-time view of your cash flow. It's a small business accounting software that’s simple, smart and occasionally magical.
                      </p>
                    </div>
                  </div>
                </li>
                <li className="mt-10">
                  <div className="flex">
                    <div className="ml-4">
                      <h5 className="text-lg leading-6 font-medium text-white">Run your business on the go.</h5>
                      <p className="mt-2 text-base leading-6 text-white">
                        Use our mobile app to reconcile, send invoices, or create expense claims - from anywhere.
                      </p>
                    </div>
                  </div>
                </li>
                <li className="mt-10">
                  <div className="flex">
                    <div className="ml-4">
                      <h5 className="text-lg leading-6 font-medium text-white">Get paid faster with online invoicing.</h5>
                      <p className="mt-2 text-base leading-6 text-white">
                        Send online invoices to your customers - and get updated when they’re opened.
                      </p>
                    </div>
                  </div>
                </li>
                <li className="mt-10">
                  <div className="flex">
                    <div className="ml-4">
                      <h5 className="text-lg leading-6 font-medium text-white">Reconcile in seconds.</h5>
                      <p className="mt-2 text-base leading-6 text-white">
                        Reconcile in seconds. Xero imports and categorises your latest bank transactions. Just click ok to reconcile.
                      </p>
                    </div>
                  </div>
                </li>
              </ul>


              <div className="flex justify-between mt-10">
                <span className="block rounded-md shadow-sm">
                  <a href="https://xero.com/signup/?xtid=x30buddy" className="flex justify-center py-2 px-4 border border-transparent font-medium rounded-md text-white focus:outline-none transition duration-150 ease-in-out" style={{backgroundColor:"#13b6ea"}}>
                    Try Xero Accounting Software For Free
                  </a>
                </span>
              </div>
            </div>

            <div className="mt-10 -mx-4 relative lg:mt-0">
              
              <img className="relative mx-auto" width="490" src={xeroSceenshot} alt=""/>
              {/*<img className="relative mx-auto" width="490" src="https://tailwindui.com/img/features/feature-example-1.png" alt=""/>*/}
            </div>
          </div>
        </div>
      </div>


      <div id='features' className="py-16 bg-gray-50 overflow-hidden lg:py-24">
        <div className="relative max-w-xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-screen-xl">
          <svg className="hidden lg:block absolute left-full transform -translate-x-1/2 -translate-y-1/4" width="404" height="784" fill="none" viewBox="0 0 404 784">
            <defs>
              <pattern id="b1e6e422-73f8-40a6-b5d9-c8586e37e0e7" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                <rect x="0" y="0" width="4" height="4" className="text-gray-200" fill="currentColor" />
              </pattern>
            </defs>
            <rect width="404" height="784" fill="url(#b1e6e422-73f8-40a6-b5d9-c8586e37e0e7)" />
          </svg>

          <div className="relative">
            <h3 className="text-center text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl sm:leading-10">
              Connect Buddy to Xero in 5 Simple Steps
            </h3>
          </div>

          <div className="relative mt-12 lg:mt-24 lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center">
            <div className="relative">
              <ul className="mt-10">
                <li>
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white font-extrabold">
                        {/* Heroicon name: globe-alt */}
                        1
                      </div>
                    </div>
                    <div className="ml-4">
                      <h5 className="text-lg leading-6 font-medium text-gray-900">Sign Up / Login to Buddy</h5>
                      <p className="mt-2 text-base leading-6 text-gray-500">
                        Sign-up to <a href="https://api.buddy.hr/v2/xero/connect" className="text-orange-400 underline">Buddy with Xero</a> or <Link to="/login" className="text-orange-400 underline">Login</Link> 
                      </p>
                    </div>
                  </div>
                </li>
                <li className="mt-10">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white font-extrabold">
                        {/* Heroicon name: lightning-bolt */}
                        2
                      </div>
                    </div>
                    <div className="ml-4">
                      <h5 className="text-lg leading-6 font-medium text-gray-900">Connect to Xero</h5>
                      <p className="mt-2 text-base leading-6 text-gray-500">
                        Go to Settings &gt; Integrations and click on Connect to Xero
                      </p>
                    </div>
                  </div>
                </li>
                <li className="mt-10">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white font-extrabold">
                        {/* Heroicon name: scale */}
                        3
                      </div>
                    </div>
                    <div className="ml-4">
                      <h5 className="text-lg leading-6 font-medium text-gray-900">Sign in to Xero &amp; Authorize Buddy</h5>
                      <p className="mt-2 text-base leading-6 text-gray-500">
                        Sign in with Xero and Authorize Buddy to connect and send data to your Xero Account.
                      </p>
                    </div>
                  </div>
                </li>
                <li className="mt-10">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white font-extrabold">
                        {/* Heroicon name: scale */}
                        4
                      </div>
                    </div>
                    <div className="ml-4">
                      <h5 className="text-lg leading-6 font-medium text-gray-900">Configure your Integration</h5>
                      <p className="mt-2 text-base leading-6 text-gray-500">
                        Once connected, go back to Company Settings &gt; Integrations
                      </p>
                      <p className="mt-2 text-base leading-6 text-gray-500">
                        Fill up the new form to properly connect Buddy to Xero by choosing the nominal codes and how you want to transfer your data.
                      </p>
                    </div>
                  </div>
                </li>
                <li className="mt-10">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white font-extrabold">
                        {/* Heroicon name: scale */}
                        5
                      </div>
                    </div>
                    <div className="ml-4">
                      <h5 className="text-lg leading-6 font-medium text-gray-900">Submit Payroll Data</h5>
                      <p className="mt-2 text-base leading-6 text-gray-500">
                        If you want to post historic payroll data to Xero, go to Payroll &gt; Payroll History.
                        Click on the Xero icon to send data for the selected payroll to Xero.
                      </p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>

            <div className="mt-10 -mx-4 relative lg:mt-0">
              
              <ul className="mt-10">
                <li>
                  <h5 className="text-lg leading-6 font-bold text-gray-900 text-center">Data Flow</h5>
                </li>
                <li className="mt-10">
                  <div className="flex justify-center">
                      <div className="flex justify-self-start items-center justify-center h-12 w-36 px-4 rounded-md bg-orange-500 text-white font-extrabold">
                        Employee
                      </div>

                      <div className="flex mx-5 items-center justify-center h-12 w-12 rounded-md text-gray-500 font-extrabold">
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path></svg>
                      </div>

                      <div className="flex justify-self-end items-center justify-center h-12 w-36 px-4 rounded-md bg-orange-500 text-white font-extrabold" style={{backgroundColor:"#13b6ea"}}>
                        Contact
                      </div>
                  </div>
                </li>

                <li className="mt-10">
                  <div className="flex justify-center">
                      <div className="flex justify-self-start items-center justify-center h-12 w-36 px-4 rounded-md bg-orange-500 text-white font-extrabold">
                        Payslip
                      </div>

                      <div className="flex mx-5 items-center justify-center h-12 w-12 rounded-md text-gray-500 font-extrabold">
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path></svg>
                      </div>

                      <div className="flex justify-self-end items-center justify-center h-12 w-36 px-4 rounded-md bg-orange-500 text-white font-extrabold" style={{backgroundColor:"#13b6ea"}}>
                        Bill
                      </div>
                  </div>
                </li>

                <li className="mt-10">
                  <div className="flex justify-center">
                      <div className="flex items-center justify-center h-12 w-36 px-4 rounded-md bg-orange-500 text-white font-extrabold">
                        Payroll Tax
                      </div>

                      <div className="flex mx-5 items-center justify-center h-12 w-12 rounded-md text-gray-500 font-extrabold">
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path></svg>
                      </div>

                      <div className="flex items-center justify-center h-12 w-36 px-4 rounded-md bg-orange-500 text-white font-extrabold" style={{backgroundColor:"#13b6ea"}}>
                        Bill
                      </div>
                  </div>
                </li>


                <li className="mt-10">
                  <h5 className="text-lg leading-6 font-bold text-gray-900 text-center">Data Relations</h5>
                </li>

                <li className="mt-10">
                  <div className="flex justify-center">
                      <div className="flex items-center justify-center h-16 w-36 px-4 rounded-md bg-orange-500 text-white font-extrabold">
                        Salary Component
                      </div>

                      <div className="flex mx-5 items-center justify-center h-16 w-12 rounded-md text-gray-500 font-extrabold">
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path></svg>
                      </div>

                      <div className="flex items-center justify-center h-16 w-36 px-4 rounded-md bg-orange-500 text-white font-extrabold" style={{backgroundColor:"#13b6ea"}}>
                        Nominal Code
                      </div>
                  </div>
                </li>

                <li className="mt-10">
                  <div className="flex justify-center">
                      <div className="flex items-center justify-center h-16 w-36 px-4 rounded-md bg-orange-500 text-white font-extrabold">
                        Department
                      </div>

                      <div className="flex mx-5 items-center justify-center h-16 w-12 rounded-md text-gray-500 font-extrabold">
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path></svg>
                      </div>

                      <div className="flex items-center justify-center h-16 w-36 px-4 rounded-md bg-orange-500 text-white font-extrabold" style={{backgroundColor:"#13b6ea"}}>
                        Tracking Option
                      </div>
                  </div>
                </li>
                
              </ul>
            </div>
          </div>

        </div>
      </div>


      {/*<MaltaFeatures/>
            <Pricing/>*/}
      <Testimonials/>
      <Security/>
      <Team/>

    </React.Fragment>
    
  );
}

const mapStateToProps = (state) => {

  return {
    bundles: state.payment.bundles
  }
}

const mapDispatchToProps = dispatch => ({
  selectBundle: (bundle) => dispatch(PAYMENTACTIONS.selectBundle(bundle)),
  getBundles: () => dispatch(PAYMENTACTIONS.getBundles()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Xero) 
